module.exports = __webpack_public_path__ + "static/media/web2011.5a41d260.jpg";